<template>
  <div>
    <div style="overflow: hidden">
      <slot name="title"> </slot>
      <span class="btn-group">
        <el-button class="explorer" size="mini" @click="explorer" v-if="!dark"
          >导出</el-button
        >
        <el-checkbox-group
          v-if="!dark"
          v-model="dataType"
          @change="onDataType"
          size="mini"
          class="datatype"
          fill="#3e7878"
        >
          <el-checkbox-button label="1">投放</el-checkbox-button>
          <el-checkbox-button label="2">站点</el-checkbox-button>
<!--          <el-checkbox-button label="3">骑行</el-checkbox-button>-->
        </el-checkbox-group>
        <el-radio-group
          @change="onTimeType"
          size="mini"
          v-model="timeType"
          style="margin-left: 16px "
          fill="#3e7878"
        >
          <el-radio-button label="日"></el-radio-button>
          <el-radio-button label="月"></el-radio-button>
          <el-radio-button label="年"></el-radio-button>
        </el-radio-group>
      </span>
    </div>
    <div v-if="timeType === '年'" class="mb20">
      <el-select
        @change="tidal"
        clearable
        size="mini"
        v-model="selectYear"
        placeholder="请选择"
      >
        <el-option
          v-for="item in selectYears"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <div id="totalChart" :style="{ height: height + 'px' }"></div>
    <!-- 一级弹窗 -->
    <w-dialog
      ref="monthchart"
      :title="dialogTitleMonth"
      width="55%"
      :className="dark ? 'i-dialog' : ''"
      :isShowFooter="false"
      @handleCloseRight="handleCloseMonth"
    >
      <template v-slot:content>
        <div id="monthchart"></div>
      </template>
    </w-dialog>
    <w-dialog
      ref="daychart"
      :title="dialogTitleDay"
      width="55%"
      :className="dark ? 'i-dialog' : ''"
      :isShowFooter="false"
      @handleCloseRight="handleCloseDay"
    >
      <template v-slot:content>
        <div id="daychart"></div>
      </template>
    </w-dialog>
  </div>
</template>

<script>
import Api from '@/api'
import { Line } from '@antv/g2plot'
import WDialog from '@/components/Model/index.vue'

export default {
  components: {
    WDialog
  },
  data() {
    return {
      chartData: [],
      height: 300,
      monthCache: null,
      chart: null, // 潮汐
      chartDays: null,
      chartMonths: null,
      timeType: '月', // 0-日，1-月，2-年
      dataType: ['1'],
      selectYear: undefined,
      selectYears: [],
      dialogTitleDay: '',
      dialogTitleMonth: '',
      // 单车品牌颜色
      brandOriginColor: {},
      // 电动车品牌颜色
      eOriginColor: {}
    }
  },
  props: {
    realHeight: {
      type: Number,
      default: 300
    },
    selfAreaId: {
      type: String,
      defalut: ''
    },
    isAggregation: {
      type: [Boolean, String],
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    initTimeType: {
      type: String,
      default: '月'
    }
  },
  watch: {
    realHeight(val) {
      if (val) {
        this.getAreaBrandDetails()
        setTimeout(() => {
          this.tidal()
        }, 1000)
      }
    }
  },
  created() {
    this.getAreaBrandDetails()
    setTimeout(() => {
      this.yearChange()
      this.timeType = this.initTimeType
      this.tidal()
    }, 1000)
  },
  methods: {
    yearChange () {
      var newDate = new Date()
      var startYear = newDate.getFullYear() - 4// 起始年份
      var endYear = newDate.getFullYear() // 结束年份
      this.selectYears = []
      for (var i = startYear; i <= endYear; i++) {
        this.selectYears.push({
          value: (i + ''),
          label: (i + '年')
        })
      }
      this.selectYears.sort((a, b) =>
        a.value < b.value ? 1 : a.value > b.value ? -1 : 0
      )
    },
    getAreaBrandDetails() {
      if (this.selfAreaId !== '') {
        try {
          const params = {
            selfAreaId: this.selfAreaId
          }
          Api.areaBrandDetails(params).then((res) => {
            if (res.code === 200) {
              const brandOriginColor = res.data.map(item => {
                return {
                  brandName: item.brandName.slice(0, 2) + '单车',
                  bikeColor: item.bikeColor
                }
              })
              // 单车
              const colorObject = brandOriginColor => {
                for (let i = 0; i < brandOriginColor.length; i++) {
                  const { brandName, bikeColor } = brandOriginColor[i]
                  this.brandOriginColor[brandName] = bikeColor
                }
                return this.brandOriginColor
              }
              this.brandOriginColor = colorObject(brandOriginColor)
              // 电动车
              const eBrandOriginColor = res.data.map(item => {
                if (item.brandName.indexOf('美团出行') > -1) {
                  return {
                    brandName: '美团电单',
                    eBikeColor: item.ebikeColor
                  }
                }
                return {
                  brandName: item.brandName,
                  eBikeColor: item.ebikeColor
                }
              })
              const eColorObject = eBrandOriginColor => {
                for (let i = 0; i < eBrandOriginColor.length; i++) {
                  const { brandName, eBikeColor } = eBrandOriginColor[i]
                  this.eOriginColor[brandName] = eBikeColor
                }
                return this.eOriginColor
              }
              this.eOriginColor = eColorObject(eBrandOriginColor)
            } else {
              this.$message.warning(res.message)
            }
          })
        } catch (e) {
          this.eOriginColor = {}
          this.brandOriginColor = {}
        }
      }
    },
    // 自行车品牌颜色
    originColor(name) {
      return this.brandOriginColor[name]
    },
    // 电动车品牌颜色
    eBrandOriginColor(name) {
      return this.eOriginColor[name]
    },
    onTimeType() {
      this.selectYear = undefined
      this.tidal()
    },
    onSelectYear() {
      this.tidal()
    },
    explorer() {
      this.$emit('explorer', this.timeType)
    },
    getTodayTime(date) {
      const day2 = date ? new Date(date) : new Date()
      day2.setTime(day2.getTime())
      return (
        day2.getFullYear() +
        '-' +
        (day2.getMonth() < 9
          ? '0' + (day2.getMonth() + 1)
          : day2.getMonth() + 1) +
        '-' +
        (day2.getDate() < 10 ? '0' + day2.getDate() : day2.getDate()) +
        '-' +
        day2.getHours() +
        '-' +
        day2.getMinutes()
      )
    },
    getSiteParams(data) {
      const vm = this
      const t = data ? vm.getTodayTime(data) : vm.getTodayTime()
      const format = t.split('-')
      return format
    },
    tidal(data, id, chartName = 'chart') {
      const vm = this
      const format = vm.selectYear
        ? vm.getSiteParams(vm.selectYear)
        : vm.getSiteParams()
      const params = {
        selfAreaId: this.selfAreaId,
        year: format[0]
      }
      if (this.timeType === '日') {
        params.month = format[1]
        params.day = format[2]
      } else if (this.timeType === '月') {
        params.month = format[1]
      }
      // 浮层数据获取参数
      if (data && data.time) {
        if (this.timeType === '月') {
          params.year = this.selectYear
            ? this.selectYear
            : new Date().getFullYear()
          params.month = this.monthCache
            ? this.monthCache
            : new Date().getMonth() < 9
              ? '0' + (new Date().getMonth() + 1)
              : new Date().getMonth() + 1
          params.day = Number(data.time) < 10 ? '0' + data.time : data.time
        } else if (this.timeType === '年') {
          params.year = this.selectYear
            ? this.selectYear
            : new Date().getFullYear()
          params.month = Number(data.time) < 10 ? '0' + data.time : data.time
        }
      }
      Api.brandBikeOnline(params)
        .then((res) => {
          if (res.code === 200) {
            vm.$nextTick(() => {
              let type = '年'
              const today = new Date()
              let slicelength = 0
              if (params.year) {
                type = '年'
                if (!params.month && params.year == today.getFullYear()) {
                  slicelength = today.getMonth() + 1
                }
              }
              if (params.month) {
                type = '月'
                if (!params.day && params.month == today.getMonth() + 1) {
                  slicelength = today.getDate()
                }
              }
              if (params.day) {
                type = '日'
                if (params.day == today.getDate()) {
                  slicelength = today.getHours() + 1
                }
              }
              if (slicelength) {
                for (const key in res.data) {
                  res.data[key] = res.data[key].slice(0, slicelength)
                }
              }
              this.chartData = res.data
              setTimeout(() => {
                this.initScale(
                  this.translateLineData(this.chartData, type),
                  id,
                  chartName
                )
              }, 1000)
            })
          } else {
            vm.$message.warning(res.message)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    color16() {
      var r = Math.floor(Math.random() * 256)
      var g = Math.floor(Math.random() * 256)
      var b = Math.floor(Math.random() * 256)
      var color = '#' + r.toString(16) + g.toString(16) + b.toString(16)
      return color
    },
    getColorsByNames() {
      const arr = []
      // 过滤重复数据
      const newRealNames = [...new Set(this.realNames)]
      this.realNames = newRealNames
      for (let i = 0, len = newRealNames.length; i < len; i++) {
        const item = newRealNames[i]
        var newItem = item
        if (item.includes('(')) {
          newItem = item.slice(0, item.length - 4)
        }
        if (item.indexOf('单车') !== -1) {
          arr.push(this.originColor(newItem) ? this.originColor(newItem) : this.color16())
        } else {
          arr.push(this.eBrandOriginColor(newItem) ? this.eBrandOriginColor(newItem) : this.color16())
        }
      }
      return arr.filter((v) => v)
    },
    translateLineData(data, datatype) {
      const arr = []
      this.realNames = []
      Object.entries(data).forEach((p, idx) => {
        const key = p[0] // 品牌的名字
        for (const val of p[1]) {
          let time = ''
          let date = ''
          if (datatype === '年') {
            time = Number(val.date.split('-')[1]) + '月'
            date = Number(val.date.split('-')[1])
          } else if (datatype === '月') {
            const day = Number(val.date.split('-')[2])
            time = Number(day) < 10 ? '0' + day : String(day)
            date = day
          } else if (datatype === '日') {
            time = val.hour + '点'
            date = val.hour
          }
          if (this.dark) {
            arr.push({
              pinpai: key, // 品牌
              date: time,
              num: val.num,
              time: date
            })
            if (!this.realNames.includes(key)) {
              this.realNames.push(key)
            }
          } else {
            // 如果 7天内 第一个单车 有数值 那每天都要有数据 补全
            if (this.dataType.includes('1')) {
              // 有投放数据
              arr.push({
                pinpai: key + '(投放)', // 品牌
                date: time,
                num: val.online_num_e + val.online_num,
                time: date
              })
              if (!this.realNames.includes(key)) {
                this.realNames.push(key + '(投放)')
              }
            }
            if (this.dataType.includes('2')) {
              // 有站点数据
              arr.push({
                pinpai: key + '(站点)', // 品牌
                date: time,
                num: val.site_num_e + val.site_num,
                time: date
              })
              if (!this.realNames.includes(key)) {
                this.realNames.push(key + '(站点)')
              }
            }
            if (this.dataType.includes('3')) {
              // 有骑行数据
              arr.push({
                pinpai: key + '(骑行)', // 品牌
                date: time,
                num: val.cycling_num + val.cycling_num_e,
                time: date
              })
              if (!this.realNames.includes(key)) {
                this.realNames.push(key + '(骑行)')
              }
            }
          }
        }
      })
      return arr
    },
    onDataType() {
      this.initScale(
        this.translateLineData(this.chartData, this.timeType),
        'totalChart',
        'chart'
      )
    },
    initScale(data, id, chartName) {
      // 有id表示自定义
      if (data.legnth == 0) {
        return
      }
      if (this[chartName]) {
        this[chartName].destroy()
      }
      let h = 70
      if (this.timeType === '年') {
        h = 110
      }
      this.height = this.realHeight - h
      this[chartName] = new Line(id || 'totalChart', {
        data: data,
        height: this.realHeight - h,
        xField: 'date',
        yField: 'num',
        seriesField: 'pinpai',
        legend: {
          position: 'top-left',
          flipPage: false,
          itemName: {
            style: {
              fill: '#999'
            }
          }
        },
        point: {
          shape: () => {
            return 'circle'
          },
          size: 3,
          color: this.getColorsByNames()
        },
        lineStyle: ({ pinpai }) => {
          // 粗的
          if (pinpai.indexOf('投放') > -1) {
            return {
              lineWidth: 3,
              lineDash: [3, 1]
            }
          } else if (pinpai.indexOf('站点') > -1) {
            return {
              lineWidth: 3
            }
          } else {
            return {
              lineWidth: 1
            }
          }
        },
        color: this.getColorsByNames()
      })
      this[chartName].on('element:click', (event) => {
        // 点击数据
        if (event && event.data && event.data.data && event.data.data.num) {
          this.onClickPoint(event.data.data)
        }
      })
      this[chartName].render()
    },
    onClickPoint(data) {
      const vm = this
      if (this.timeType === '日') {
      } else if (this.timeType === '月') {
        vm.dialogTitleDay =
          new Date().getFullYear() +
          '-' +
          (new Date().getMonth() + 1) +
          '-' +
          data.time +
          (vm.dark ? '曲线图' : ' 品牌投放量曲线')
        vm.$refs.daychart.onShowDialog()
        vm.$nextTick(() => {
          vm.tidal(data, 'daychart', 'chartDays')
        })
      } else if (this.timeType === '年') {
        vm.monthCache = Number(data.time) < 10 ? '0' + data.time : data.time
        if (vm.selectYear) {
          vm.dialogTitleMonth =
            vm.selectYear +
            '-' +
            data.time +
            (vm.dark ? '曲线图' : ' 品牌投放量曲线')
        } else {
          vm.dialogTitleMonth =
            new Date().getFullYear() +
            '-' +
            data.time +
            (vm.dark ? '曲线图' : ' 品牌投放量曲线')
        }
        vm.$refs.monthchart.onShowDialog()
        vm.$nextTick(() => {
          vm.tidal(data, 'monthchart', 'chartMonths')
        })
      }
    },
    handleCloseMonth() {
      this.monthCache = null
      this.$refs.monthchart.onCloseDialog()
    },
    handleCloseDay() {
      this.$refs.daychart.onCloseDialog()
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  display: inline-block;
}

.btn-group {
  float: right;

  .datatype {
    margin-left: 16px;
    display: inline-block;
    line-height: 1;
    vertical-align: middle;
  }
}
</style>
